import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BookingTimesServiceConfig = {
  name: "BookingTimes",
  annotations: []
} as ServiceConfig;